(function () {
  var GRIND_SELECTOR = '[data-grind-dropdown]';
  var PRODUCT_JSON_SELECTOR = '[data-product-json]';
  var HIDDEN_CLASS = 'hidden';

  function normalizeValue(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function parseWeightRules(rawValue) {
    return (rawValue || '')
      .split(',')
      .map(function (value) {
        return normalizeValue(value);
      })
      .filter(Boolean);
  }

  function variantMatchesWeightRule(variant, weightRules) {
    var variantValues;

    if (!variant || !weightRules.length) return false;

    variantValues = [variant.title].concat(variant.options || []).map(function (value) {
      return normalizeValue(value);
    });

    return weightRules.some(function (rule) {
      return variantValues.some(function (value) {
        return value.indexOf(rule) > -1;
      });
    });
  }

  function toggleGrindField(grindBlock, variant) {
    var weightRules = parseWeightRules(grindBlock.dataset.grindHideWeights);
    var shouldHide = variantMatchesWeightRule(variant, weightRules);
    var grindInput = grindBlock.querySelector('[data-grind-input]');

    grindBlock.classList.toggle(HIDDEN_CLASS, shouldHide);

    if (grindInput) {
      grindInput.disabled = shouldHide;
    }
  }

  function getInitialVariant(container) {
    var productJson = container.querySelector(PRODUCT_JSON_SELECTOR);
    var product;

    if (!productJson) return null;

    try {
      product = JSON.parse(productJson.textContent);
      return product.selected_or_first_available_variant || product.variants[0] || null;
    } catch (error) {
      console.warn('Unable to parse product JSON for grind dropdown', error);
      return null;
    }
  }

  function initGrindDropdown(grindBlock) {
    var container = grindBlock.closest('[data-section-type="product"]');

    if (!container) return;

    toggleGrindField(grindBlock, getInitialVariant(container));

    container.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant ? event.detail.variant : null;
      toggleGrindField(grindBlock, variant);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(GRIND_SELECTOR), initGrindDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener("DOMContentLoaded", () => {
    const sizeRadios = document.querySelectorAll(
      '.radio__fieldset .radio__button input[type="radio"]'
    );
    const grindSelect = document.querySelector(".grind__select");

    // Parse the hide weights list from the dataset
    const hideWeights = grindSelect.dataset.grindHideWeights
      .split(",")
      .map(w => w.trim().toLowerCase());

    function updateGrindVisibility(value) {
      const shouldHide = hideWeights.some(weight => value.includes(weight));
      const grindButton = grindSelect.querySelector("button.select-popout__toggle");
      const grindInput = grindSelect.querySelector("input[data-grind-input]");

      if (shouldHide) {
        grindSelect.style.display = "none";
        grindSelect.style.opacity = "0";

        if (grindButton) {
          grindButton.setAttribute("disabled", "true");
          grindButton.setAttribute("aria-disabled", "true");
          grindButton.classList.add("btn-disabled"); // add custom class
        }
        if (grindInput) grindInput.setAttribute("disabled", "true");
      } else {
        grindSelect.style.display = "grid"; // restore grid
        grindSelect.style.opacity = "1";

        if (grindButton) {
          grindButton.removeAttribute("disabled");
          grindButton.removeAttribute("aria-disabled");
          grindButton.classList.remove("btn-disabled");
        }
        if (grindInput) grindInput.removeAttribute("disabled");
      }
    }


    // Run once on page load
    const checkedRadio = document.querySelector(
      '.radio__fieldset .radio__button input[type="radio"]:checked'
    );
    if (checkedRadio) {
      updateGrindVisibility(checkedRadio.value.toLowerCase());
    }

    // Attach listeners for changes
    sizeRadios.forEach(radio => {
      radio.addEventListener("change", () => {
        updateGrindVisibility(radio.value.toLowerCase());
      });
    });
  });
})();
